<div>
  <div *ngIf="allPosts.length > 0; else loading">
    <ul style="list-style: none;">
      <div *ngFor="let post of allPosts">
        <li><a routerLink="/feed-feature/{{post.id}}">{{post.title.rendered}}</a></li>
      </div>
    </ul>
  </div>
  <ng-template #loading>
    <p>Loading...</p>
  </ng-template>
</div>